import React from 'react';

import { SkeletonProfileImage, SkeletonBody } from '@xingternal/skeleton';

import styles from './Skeleton.css';

const UserCardSkeleton = () => (
  <div className={styles.container}>
    <div className={styles.infoWrapper}>
      <SkeletonProfileImage className={styles.logoImageContainer} />
      <div className={styles.userInfo}>
        <SkeletonBody
          variant="primary"
          size="small"
          amountRows={1}
          className={styles.titleSkeleton}
        />
        <SkeletonBody
          variant="primary"
          size="small"
          amountRows={2}
          className={styles.bodySkeleton}
        />
      </div>
    </div>
  </div>
);

export default UserCardSkeleton;
